import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { useAuth } from "oidc-react";
import AuthStatusCard from "components/common/AuthStatusCard";
import { hasRequiredOidcConfig } from "services/oidcConfig";

export default function Login() {
  const auth = useAuth();

  return (
    <AuthStatusCard
      icon={<ShieldOutlinedIcon />}
      title="Connecting to Recon Tool"
      progressLabel={hasRequiredOidcConfig ? "Redirecting to SSO..." : undefined}
      warning={
        !hasRequiredOidcConfig
          ? "Missing required OIDC environment variables. Check `.env.local` before starting the app locally."
          : undefined
      }
      actions={[
        {
          label: auth.isLoading ? "Connecting..." : "Retry SSO",
          onClick: () => void auth.signIn(),
          disabled: !hasRequiredOidcConfig || auth.isLoading,
          icon: <LoginRoundedIcon />,
        },
        {
          label: "Reload page",
          onClick: () => window.location.reload(),
          variant: "secondary",
        },
      ]}
      helperText={
        <>
          If the browser opens but stays unauthenticated, confirm the redirect URI in your Cognito app matches
          `http://localhost:3000` for local work.
        </>
      }
    />
  );
}
